import { j as jsxRuntimeExports } from "./jsx-runtime-ClFauRgV.mjs";
import React__default, { createContext, useContext } from "react";
import { styled, css } from "styled-components";
import { T as TOKENS, B as BREAKPOINTS, f as fontSizeRem } from "./tokens-DINeGuB9.mjs";
const KindredConfigContext = createContext(void 0);
KindredConfigContext.displayName = "KindredConfigContext";
const KindredConfigProvider = ({
  config,
  children
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(KindredConfigContext.Provider, { value: config ?? void 0, children });
};
const useKindredConfigOptional = () => useContext(KindredConfigContext);
const verticalSpaceStyles = css`
  ${({
  $marginTop
}) => $marginTop && css`
      margin-top: var(${TOKENS.dimension.space[$marginTop]});
    `}

  ${({
  $marginBottom
}) => $marginBottom && css`
      margin-bottom: var(${TOKENS.dimension.space[$marginBottom]});
    `}
`;
const BODY_ELEMENTS = ["p", "span"];
const BODY_SIZES = ["xLarge", "large", "medium", "small", "xSmall"];
const BODY_COLORS = ["default", "subdued"];
const BODY_FONT_SIZE_BY_SIZE = {
  xLarge: {
    mobile: fontSizeRem("21"),
    tablet: fontSizeRem("24"),
    desktop: fontSizeRem("24")
  },
  large: {
    mobile: fontSizeRem("18"),
    tablet: fontSizeRem("20"),
    desktop: fontSizeRem("20")
  },
  medium: {
    mobile: fontSizeRem("16"),
    tablet: fontSizeRem("16"),
    desktop: fontSizeRem("16")
  },
  small: {
    mobile: fontSizeRem("14"),
    tablet: fontSizeRem("14"),
    desktop: fontSizeRem("14")
  },
  xSmall: {
    mobile: fontSizeRem("12"),
    tablet: fontSizeRem("12"),
    desktop: fontSizeRem("12")
  }
};
const BODY_LINE_HEIGHT_BY_SIZE = {
  xLarge: 160,
  large: 150,
  medium: 160,
  small: 140,
  xSmall: 140
};
const bodyStyles = ({
  responsive = true
} = {}) => css`
    font-family: var(${TOKENS.text.fontFamily.primary});
    font-weight: var(${TOKENS.text.fontWeight.default});
    margin: 0;

    ${({
  $color = "default"
}) => `
      color: var(${$color === "subdued" ? TOKENS.color.foreground.subdued : TOKENS.color.foreground.default});
    `}

    ${({
  $size
}) => `
      font-size: ${BODY_FONT_SIZE_BY_SIZE[$size].desktop};
    `}

    ${({
  $size
}) => responsive ? `
          /* Desktop-first step-downs. Larger breakpoint first so mobile wins below sm. */
          @media (max-width: ${BREAKPOINTS.md}) {
            font-size: ${BODY_FONT_SIZE_BY_SIZE[$size].tablet};
          }

          @media (max-width: ${BREAKPOINTS.sm}) {
            font-size: ${BODY_FONT_SIZE_BY_SIZE[$size].mobile};
          }
        ` : ""}
  `;
const StyledBody = styled.p`
  ${bodyStyles()}

  ${({
  $size
}) => `
    line-height: ${BODY_LINE_HEIGHT_BY_SIZE[$size]}%;
  `}

 ${({
  $bold
}) => $bold && "font-weight: 700;"}
 ${verticalSpaceStyles}
`;
const Body = React__default.forwardRef(({
  as,
  bold = false,
  color = "default",
  marginBottom,
  marginTop,
  size,
  children,
  ...props
}, ref) => /* @__PURE__ */ jsxRuntimeExports.jsx(StyledBody, { ...props, $bold: bold, $color: color, $marginBottom: marginBottom, $marginTop: marginTop, $size: size, as, "data-kindred": "body", ref, children }));
export {
  BODY_COLORS as B,
  KindredConfigProvider as K,
  BODY_ELEMENTS as a,
  BODY_SIZES as b,
  Body as c,
  bodyStyles as d,
  useKindredConfigOptional as u,
  verticalSpaceStyles as v
};
